import PublicPageLayout from './PublicPageLayout';

type Tool = { name: string; role: string; icon: string };

const AI_TOOLS: Tool[] = [
  { name: 'Claude Code', role: 'архитектура, код, ревью', icon: '/branding/tools/anthropic.png' },
  { name: 'Gemini', role: 'большие объёмы контекста, разбор документации', icon: '/branding/tools/gemini.png' },
  { name: 'DeepSeek', role: 'агентские правки и тесты', icon: '/branding/tools/deepseek.png' },
  { name: 'OpenCode', role: 'среда, в которой работают агенты', icon: '/branding/tools/opencode.png' },
];

const STACK: Tool[] = [
  { name: 'Kotlin + Compose', role: 'Android и Windows из одного кода', icon: '/branding/tools/kotlin.png' },
  { name: 'Spring Boot', role: 'серверная часть на Java 21', icon: '/branding/tools/spring.png' },
  { name: 'React + TypeScript', role: 'веб-клиент', icon: '/branding/tools/react.png' },
  { name: 'PostgreSQL', role: 'сообщения, чаты, файлы', icon: '/branding/tools/postgresql.png' },
  { name: 'Redis', role: 'доставка событий и счётчики', icon: '/branding/tools/redis.png' },
  { name: 'Docker + Caddy', role: 'развёртывание и TLS', icon: '/branding/tools/docker.png' },
];

export default function PublicInfoPage() {
  return (
    <PublicPageLayout path="/info" title="О проекте">
      <section className="public-hero">
        <h1>Мессенджер, который мы делаем для себя</h1>
        <p className="public-lead">
          HomeChat — не продукт для рынка. Это личный мессенджер на несколько сотен человек:
          переписка, медиа, голосовые, звонки и сторис на своём сервере. Работает в браузере,
          на Android и на Windows — один аккаунт на всех устройствах.
        </p>
      </section>

      <section className="public-section">
        <h2>Зачем</h2>
        <p>
          Хотелось свой канал связи: без рекламы, без чужой модерации и с понятным ответом на вопрос,
          где лежат данные. Заодно это честный способ проверить, как далеко можно уйти в реальном
          проекте, где есть база данных, миграции, фоновые задачи, мобильные клиенты и деплой.
        </p>
        <p>
          Всё живёт на домашнем сервере под Docker Compose, наружу смотрит через отдельный релей.
          Резервные копии базы и медиа делаются автоматически.
        </p>
      </section>

      <section className="public-section">
        <h2>Что уже работает</h2>
        <div className="public-chips">
          {[
            'личные чаты и группы', 'медиа и альбомы', 'голосовые и кружки', 'реакции и пересылка',
            'папки и архив', 'закреплённые сообщения', 'поиск по переписке', 'звонки 1:1 и групповые',
            'сторис', 'push-уведомления', 'QR-вход и 2FA', 'админ-панель', 'резервные копии',
          ].map((item) => <span className="public-chip" key={item}>{item}</span>)}
        </div>
      </section>

      <section className="public-section">
        <h2>Масштаб</h2>
        <p>
          Около 1 200 коммитов, ~118 тысяч строк кода (сервер, два мобильных клиента и веб) и больше
          250 файлов тестов. Три независимых клиента и один сервер — общий контракт API лежит в
          отдельном OpenAPI-файле, из него генерируются типы для веба.
        </p>
      </section>

      <section className="public-section">
        <h2>Чем сделано</h2>
        <p>
          Проект ведёт владелец вместе с ИИ-агентами: одни планируют и пишут код, другие проверяют
          диффы и гоняют тесты. Ниже — модели и инструменты, которые реально участвовали.
        </p>
        <div className="public-tools">
          {AI_TOOLS.map((tool) => (
            <div className="public-tool" key={tool.name}>
              <img src={tool.icon} alt="" width={26} height={26} loading="lazy" />
              <span>
                <span className="public-tool-strong">{tool.name}</span>
                <span className="public-tool-muted">{tool.role}</span>
              </span>
            </div>
          ))}
        </div>
      </section>

      <section className="public-section">
        <h2>Стек</h2>
        <div className="public-tools">
          {STACK.map((tool) => (
            <div className="public-tool" key={tool.name}>
              <img src={tool.icon} alt="" width={26} height={26} loading="lazy" />
              <span>
                <span className="public-tool-strong">{tool.name}</span>
                <span className="public-tool-muted">{tool.role}</span>
              </span>
            </div>
          ))}
        </div>
      </section>

      <section className="public-section">
        <h2>Попробовать</h2>
        <p>Приложения для Android и Windows — на странице загрузки, веб-версия открывается сразу в браузере.</p>
        <div className="public-actions">
          <a className="public-button" href="/download">Скачать приложение</a>
          <a className="public-button ghost" href="/">Открыть веб-версию</a>
        </div>
      </section>
    </PublicPageLayout>
  );
}
